import { BindingCreator } from '@dreryk/react-common';
import { Checkbox } from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../../translations';

const FIELD_NAME = 'includeVisitsFinishedNotApproved';

export type IncludeVisitsFinishedNotApprovedCheckboxFieldValue = {
   [FIELD_NAME]: boolean;
};

type IncludeVisitsFinishedNotApprovedCheckboxProps = {
   readonly register: BindingCreator<IncludeVisitsFinishedNotApprovedCheckboxFieldValue, typeof FIELD_NAME>;
};

export const IncludeVisitsFinishedNotApprovedCheckbox = (
   props: IncludeVisitsFinishedNotApprovedCheckboxProps
): JSX.Element => {
   return (
      <Checkbox
         controller={props.register(FIELD_NAME)}
         testId={FIELD_NAME}
         label={statisticsTranslationKeys.formFields.includeVisitsFinishedNotApproved.label}
      />
   );
};
